// extracted by mini-css-extract-plugin
export default {"powered-by":"_poweredby_icon-powered-by-5b010e"};